<template>
    <div class="w-full">
        <RegisterContainer class="register__page" />
    </div>
</template>

<script>
    import {
        mapActions,
        mapGetters,
    } from 'vuex';

    import { antiFraudService } from '@core/services/antiFraud/AntiFraudService';
    import RegisterContainer from '@accountCountries/registration/RegisterContainer.vue';
    import { shellLocalConfig } from '@src/config/shell/localConfig';
    import Vue from 'vue';
    import {
        AnalyticsProtoEvents,
        AnalyticsEventTypes,
    } from '@app/utils/analyticsScreenNames';
    import { wafService } from '@core/services/waf/WafService';
    import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

    export default {
        name: 'RegisterPage',
        mounted() {
            wafService.maybeLoadWafScript();
            if (shellLocalConfig.seonConfig.register.isServiceEnabled) {
                antiFraudService.initialize(this.config.antiFraud);
            }

            const { screenName, modalName } = this.$route.params;

            this.isScreenOpenAccountOpenSent = shellLocalConfig.isScreenOpenAccountOpenSent;
            if (this.isScreenOpenAccountOpenSent) {
                const payload = {
                    eventType: AnalyticsEventTypes.accountOpen,
                    screenOpenAccountOpen: {
                        screenName,
                        modalName,
                    },
                    AnalyticsEvent: AnalyticsProtoEvents.screenOpenAccountOpen,
                };
                // @TODO(corneliu-iancu): Temporary dual analytics implementation.
                // We are currently in the process of migrating from $superAnalytics to AnalyticsSDK.
                // Both libraries are being used in parallel to validate data consistency between them.
                // DO NOT modify or remove calls to $superAnalytics until the migration is fully validated and approved.
                // Once validation is complete, $superAnalytics will be deprecated and removed.
                AnalyticsSDK.getInstance().log('account_open', {
                    screen_name: screenName,
                    modal_name: modalName,
                });
                Vue.prototype.$superAnalytics.sendEvent(payload);
            }
        },
        computed: {
            ...mapGetters('data/country', [
                'config',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'addAfterCloseHook',
            ]),
        },
        components: {
            RegisterContainer,
        },
    };
</script>
